// @ts-nocheck
// TODO: This must already exist somewhere, right? 🤔
// Ref: https://www.w3.org/TR/uievents-key/#named-key-attribute-values
export enum Keys {
    Space = " ",
    Enter = "Enter",
    Escape = "Escape",
    Backspace = "Backspace",
    Delete = "Delete",

    ArrowLeft = "ArrowLeft",
    ArrowUp = "ArrowUp",
    ArrowRight = "ArrowRight",
    ArrowDown = "ArrowDown",

    Home = "Home",
    End = "End",

    PageUp = "PageUp",
    PageDown = "PageDown",

    Tab = "Tab",
}
